import KegiatanApi from "./KegiatanApi"

export default KegiatanApi